import React, { useCallback, useEffect, useRef, useState } from "react";
import { CardTable } from "../../../components/Card/CardTable";
import { AdminGeneralTable, ProjectInfo } from "./components";
import download from '../../../assets/icons/download.svg'
import { getAdminHours } from "../../../config";
import useYear from "../../../hooks/Year";

const initFilters = { status: null, size: null }
export const PageAnalitysSizeProyect = () => {
    const totalRef = useRef()
    const averageRef = useRef()
    const projectsRef = useRef()
    const [projects, setProjects] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const { listOfYears, updateYear, year } = useYear(5);
    const [filterValue, setFilterValue] = useState(initFilters);
    const [filteredProjects, setFilteredProjects] = useState([]);


    useEffect(() => {
        setIsLoading(true);
        getAdminHours(year).then(({ payload }) => {
            setProjects(payload);
            setFilteredProjects(payload);
            setFilterValue(initFilters)
        }).finally(() => setIsLoading(false))
    }, [year]);

    const filterProject = useCallback((sizes = [], status = []) => {
        if (sizes === null && status === null) setFilteredProjects(projects);
        const newProjects = projects.filter(project => {
            const matchesSize = sizes === null || sizes.includes(project.size);
            const matchesStatus = status === null || status.includes(project.status);

            return matchesSize && matchesStatus;
        });
        setFilteredProjects(newProjects);
    }, [projects])


    const downloadAllCSV = () => {
        totalRef.current.link.click();
        averageRef.current.link.click();
        projectsRef.current.link.click();
    };



    return (
        <div className="w-full h-full grow  p-4">
            <CardTable title="Análisis de porcentaje de planeación" currentValue={year} listValues={listOfYears} updateValue={updateYear} l >
                <div className="w-full h-full  flex flex-col ">
                    <div>
                        <button onClick={downloadAllCSV} className="flex justify-center items-center w-full h-10 bg-[#1677FF] py-3 px-6 text-white  text-xs font-bold rounded-md md:absolute md:top-5 md:right-[120px] z-10 md:w-[189px]">
                            <img src={download} alt="dowloadn" />
                            <span className="w-[220px] ">Descargar tablas</span>
                        </button>        </div>

                    <div className="w-full  pt-6  ">
                        <AdminGeneralTable projects={filteredProjects} isLoading={isLoading} buttonAverageRef={averageRef} buttonTotalRef={totalRef} />
                    </div>
                    <div className="w-full flex   grow  h-full  ">
                        <ProjectInfo isLoading={isLoading} projects={projects} filterProject={filterProject} filterValue={filterValue} filteredProjects={filteredProjects} setFilterValue={setFilterValue} projectsRef={projectsRef} />
                    </div>
                </div>
            </CardTable>

        </div>
    );
};

